import React from 'react'
import PropTypes from 'prop-types'

import { useLazyLoad } from '_hooks'

import './styles.scss'

const AgeDistribution = ({ data, height, width }) => {
  const [{ BarChart, Bar, XAxis, YAxis, LabelList }, loadingRecharts] = useLazyLoad(
    import('recharts')
  )

  return (
    <If condition={!loadingRecharts}>
      <BarChart
        width={width}
        height={height}
        data={data}
        layout="vertical"
        className="bar-chart-recharts"
      >
        <defs>
          <linearGradient id="colorUv" x1="0" y1="0" x2="1" y2="0">
            <stop offset="5%" stopColor="#3fb59b" />
            <stop offset="95%" stopColor="#2a9066" />
          </linearGradient>
        </defs>
        <XAxis dataKey="value" type="number" hide domain={[0, 100]} />
        <YAxis dataKey="key" type="category" axisLine={false} tickLine={false} width={150} />
        <Bar
          dataKey="value"
          fill="url(#colorUv)"
          background={{
            radius: 20,
          }}
          barSize={40}
          radius={50}
          isAnimationActive={false}
        >
          <LabelList
            dataKey="value"
            formatter={(value) => (value > 5 ? `${value}%` : '')}
            position="inside"
            fill="white"
          />
        </Bar>
      </BarChart>
    </If>
  )
}

AgeDistribution.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
    })
  ).isRequired,
  width: PropTypes.number,
  height: PropTypes.number,
}

AgeDistribution.defaultProps = {
  width: 640,
  height: 230,
}

export default AgeDistribution
